
import { useState } from 'react';
import InterestModal from './InterestModal';
import BrandGlitch from './BrandGlitch';

export default function HeroSection() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  
  const stats = [
    { number: '10,000+', label: 'مستفيد متوقع سنويًا' },
    { number: '50+', label: 'مشروع ناشئ' },
    { number: '15+', label: 'شريك استراتيجي' }
  ];

  void stats;

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden pb-32">
      {/* Background Image with Overlay - Moved to back layer */}
      <div className="absolute inset-0 z-0">
        <img
          src="/hero-space.png"
          alt="مساحة شباب"
          className="w-full h-full object-cover object-center"
          onError={(e) => {
            const target = e.target as HTMLImageElement;
            target.src = 'https://images.unsplash.com/photo-1497366811353-6870744d04b2?w=1920&h=1080&fit=crop&q=80';
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70"></div>
      </div>

      {/* Content - Right Side */}
      <div className="relative z-20 container mx-auto px-6 lg:px-12 flex justify-start pt-40 pb-20">
        <div className="lg:w-1/2 lg:pl-12">
          {/* Logo */}
          <div className="mb-5">
            <img 
              src="/logo-diwan.png" 
              alt="ديوان - جمعية ديوان الشبابية"
              className="h-24 w-auto object-contain brightness-0 invert drop-shadow-lg"
              onError={(e) => {
                // Fallback to icon if image not found
                const target = e.target as HTMLImageElement;
                target.style.display = 'none';
                const parent = target.parentElement;
                if (parent) {
                  parent.innerHTML = '<div class="w-10 h-10 bg-white rounded-full flex items-center justify-center"><i class="ri-lightbulb-flash-line text-[#2F4F9F] text-xl"></i></div>';
                }
              }}
            />
          </div>

          {/* Brand Glitch Component */}
          <BrandGlitch />

          {/* Subheading */}
          <p className="text-lg lg:text-xl text-white mb-8 leading-relaxed drop-shadow-md max-w-xl">
            بيئة متكاملة تجمع بين العمل، التطوير، التفكير، الترفيه، وبناء المستقبل
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-wrap gap-3">
            <button 
              onClick={() => setIsModalOpen(true)}
              className="bg-gradient-to-r from-[#FF6B6B] to-[#FF8E53] text-white px-6 py-2.5 rounded-full font-semibold text-sm hover:shadow-xl transition-all duration-300 hover:scale-105 flex items-center gap-2 whitespace-nowrap cursor-pointer"
            >
              <span>كن شريكاً استراتيجياً</span>
              <i className="ri-arrow-left-line text-sm"></i>
            </button>
          </div>
        </div>
      </div>

      {/* Interest Modal */}
      <InterestModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)}
        projectName="مساحة شباب - YOUTH SPACE"
      />
    </section>
  );
}
